export default [
  {
    id: 'C032',
    date: '1796',
    request: 'Vinegar',
    reason: '',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'C032',
    date: '1796',
    request: 'Beans',
    reason: '',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'D057',
    date: '1798',
    request: 'BBQ Chips',
    reason: 'I just really want them',
    approval: 'NO',
    approvalReason: 'Have better taste',
    stock: 'X',
  },
  {
    id: 'D057',
    date: '1799',
    request: 'Salt and Vinegar Chips',
    reason: "If I find any I'm taking half",
    approval: 'YES',
    approvalReason: '',
    stock: 'P',
  },
  {
    id: 'A003',
    date: '1802',
    request: 'C Batteries',
    reason: '',
    approval: 'YES',
    approvalReason: '',
    stock: 'P',
  },
  {
    id: 'C113',
    date: '1803',
    request: 'Scrap Metal',
    reason: 'Repairs',
    approval: 'YES',
    approvalReason: '',
    stock: 'P',
  },
  {
    id: 'C044',
    date: '1806',
    request: 'Ice Pack',
    reason: 'sprained my ankle',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'C113',
    date: '1809',
    request: 'Copper Wire',
    reason: 'Computer Repairs',
    approval: 'YES',
    approvalReason: '',
    stock: 'P',
  },
  {
    id: 'C113',
    date: '1809',
    request: 'Motherboard',
    reason: 'Computer Repairs',
    approval: 'YES',
    approvalReason: '',
    stock: 'P',
  },
  {
    id: 'B005',
    date: '1810',
    request: 'Hydrogen Peroxide',
    reason: 'Medical Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B005',
    date: '1810',
    request: 'Bandages',
    reason: 'Medical Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B005',
    date: '1810',
    request: 'Anti Diarrheal',
    reason: 'Medical Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B005',
    date: '1810',
    request: 'Ibuprofen',
    reason: 'Medical Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B005',
    date: '1810',
    request: 'Pears',
    reason: 'Naive Optimism',
    approval: 'NO',
    approvalReason: "It's time to let pears go",
    stock: 'X',
  },
  {
    id: 'D073',
    date: '1814',
    request: 'Car Tires',
    reason: 'Need Rubber',
    approval: 'NO',
    approvalReason: "Don't have the man power",
    stock: 'X',
  },
  {
    id: 'B006',
    date: '1817',
    request: 'Soil Samples',
    reason: 'Monthly Check',
    approval: 'YES',
    approvalReason: 'Will try to find a new area',
    stock: 'P',
  },
  {
    id: 'D059',
    date: '1818',
    request: 'Broom',
    reason: 'Old one broke',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'C032',
    date: '1821',
    request: 'Bleach',
    reason: 'Kitchen Deep Clean',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'D061',
    date: '1823',
    request: 'Blanket',
    reason: 'I get cold at night',
    approval: 'NO',
    approvalReason: 'Suck it up, Doug',
    stock: 'X',
  },
  {
    id: 'B012',
    date: '1824',
    request: 'Vials',
    reason: 'Lab Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B012',
    date: '1824',
    request: 'Test Tubes',
    reason: 'Lab Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B012',
    date: '1824',
    request: 'Masks',
    reason: 'Lab Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
  {
    id: 'B012',
    date: '1824',
    request: 'Gloves',
    reason: 'Lab Restock',
    approval: 'YES',
    approvalReason: '',
    stock: 'S',
  },
]
